export const Checkbox = (props) => {
  // const { fill='#eee', width='17.664', height='10.908' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
      <path id="Icon_material-check-box-outline-blank" data-name="Icon material-check-box-outline-blank" d="M19.611,6.389V19.611H6.389V6.389H19.611m0-1.889H6.389A1.894,1.894,0,0,0,4.5,6.389V19.611A1.894,1.894,0,0,0,6.389,21.5H19.611A1.894,1.894,0,0,0,21.5,19.611V6.389A1.894,1.894,0,0,0,19.611,4.5Z" transform="translate(-4.5 -4.5)"/>
    </svg>
  );
}

export const CheckboxActive = (props) => {
  // const { fill='#eee', width='17.664', height='10.908' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
      <path id="Icon_material-check-box" data-name="Icon material-check-box" d="M19.611,4.5H6.389A1.888,1.888,0,0,0,4.5,6.389V19.611A1.888,1.888,0,0,0,6.389,21.5H19.611A1.888,1.888,0,0,0,21.5,19.611V6.389A1.888,1.888,0,0,0,19.611,4.5Zm-8.5,13.222L6.389,13l1.332-1.332,3.391,3.381,7.168-7.168,1.332,1.341Z" transform="translate(-4.5 -4.5)"/>
    </svg>
  );
}